module.exports = __webpack_public_path__ + "static/media/menuTTS.bc74c42d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/menuTTS.svg
// module id = 486
// module chunks = 0